import { Injectable } from "@angular/core";
import { ContactDialogComponent } from "./contact-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";

import { ContactWeb } from "src/app/models";

@Injectable({
  providedIn: "root"
})

export class ContactDialogService
{

  constructor(public dialog: MatDialog) { }

  public openDialog(contact: ContactWeb): MatDialogRef<ContactDialogComponent>
  {
    const dialogRef = this.dialog.open(ContactDialogComponent, {
      width: "450px",
      data: contact,
      disableClose: true
    });

    return dialogRef;
  }
}
